import Swiper from 'swiper';
import { md } from '../common';

export function initNewsPage() {
  new Swiper('.news__categories .swiper', {
    direction: 'horizontal',
    slidesPerView: 'auto',
    breakpoints: {
      [md]: {
        enabled: false,
      },
    },
  });

  console.log('📄 News page initialized.');
}
